import { memo } from 'react';
import { cn } from '@divlab/divanui';

import Img from '@UI/Img';
import images from '../assets';
import styles from './OurWorkGallery.module.css';

import type { FC } from 'react';
import type { OurWorksData } from '@Pages/PageExpressDesign/type';

export interface OurWorkGalleryProps {
  className?: string;
  collapsed?: boolean;
  items: OurWorksData[];
}

const OurWorkGallery: FC<OurWorkGalleryProps> = (props) => {
  const { className, items, collapsed } = props;

  return (
    <div className={cn(styles.grid, { [styles.collapsed]: collapsed }, className)}>
      {items.map((img) => (
        <div key={img.src} className={styles.imageItem}>
          <Img className={styles.interiorImage} cnImage={styles.cnImage} src={images[img.src]} />
        </div>
      ))}
    </div>
  );
};

export default memo(OurWorkGallery);
